(function () {
  function initScrim(scrim) {
    if (!scrim || scrim.getAttribute('data-bbsc-ready') === '1') return;
    scrim.setAttribute('data-bbsc-ready', '1');
    var scrimId = scrim.id;
    if (!scrimId) return;

    function openScrim() {
      scrim.classList.add('is-open');
      scrim.removeAttribute('hidden');
      scrim.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('bbsc-scroll-lock');
    }

    function closeScrim() {
      scrim.classList.remove('is-open');
      scrim.setAttribute('hidden', '');
      scrim.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bbsc-scroll-lock');
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-bbsc-open="' + scrimId + '"]');
      if (openBtn) {
        e.preventDefault();
        openScrim();
        return;
      }
      if (e.target.closest('[data-bbsc-close]') && scrim.contains(e.target)) {
        closeScrim();
        return;
      }
      if (e.target === scrim) {
        closeScrim();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && scrim.classList.contains('is-open')) {
        closeScrim();
      }
    });

    if (!scrim.getAttribute('data-bbsc-unit')) {
      scrim.setAttribute('data-bbsc-unit', 'cm');
    }
    var unitToggle = scrim.querySelector('[data-bbsc-unit-toggle]');
    if (unitToggle) {
      unitToggle.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bbsc-unit]');
        if (!btn) return;
        var unit = btn.getAttribute('data-bbsc-unit');
        unitToggle.querySelectorAll('[data-bbsc-unit]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        scrim.setAttribute('data-bbsc-unit', unit);
      });
    }

    var genderTabs = scrim.querySelector('[data-bbsc-gender-tabs]');
    if (genderTabs) {
      var genderTabButtons = Array.prototype.slice.call(genderTabs.querySelectorAll('[data-bbsc-gender-tab]'));
      function activateGenderTab(idx, focusTab) {
        genderTabButtons.forEach(function (b) {
          var active = b.getAttribute('data-bbsc-gender-tab') === idx;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
          b.setAttribute('tabindex', active ? '0' : '-1');
          if (active && focusTab) b.focus();
        });
        scrim.querySelectorAll('[data-bbsc-gender-panel]').forEach(function (panel) {
          var active = panel.getAttribute('data-bbsc-gender-panel') === idx;
          panel.classList.toggle('is-active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      }
      genderTabs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bbsc-gender-tab]');
        if (!btn || !genderTabs.contains(btn)) return;
        activateGenderTab(btn.getAttribute('data-bbsc-gender-tab'), false);
      });
      genderTabs.addEventListener('keydown', function (e) {
        var current = e.target.closest('[data-bbsc-gender-tab]');
        if (!current || !genderTabs.contains(current)) return;
        var i = genderTabButtons.indexOf(current);
        if (i < 0) return;
        var next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          if (scrim.getAttribute('dir') === 'rtl') dir *= -1;
          next = (i + dir + genderTabButtons.length) % genderTabButtons.length;
        } else if (e.key === 'Home') {
          next = 0;
        } else if (e.key === 'End') {
          next = genderTabButtons.length - 1;
        }
        if (next < 0) return;
        e.preventDefault();
        activateGenderTab(genderTabButtons[next].getAttribute('data-bbsc-gender-tab'), true);
      });
    }

    scrim.querySelectorAll('[data-bbsc-acc-head]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.bbsc-acc-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        scrim.querySelectorAll('.bbsc-acc-item').forEach(function (i) {
          i.classList.remove('is-open');
        });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bbsc-scrim]').forEach(initScrim);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
